import AutoComplete from '@app/application/miscellaneous/handlers/autocomplete/async-auto-complete'

const noop = () => {}

export default ({ onDomLoad, typeahead }) =>
  ({ cocoonSelector, path, textfieldSelector }) => {
    let removeListeners = noop

    const makeSetupTextFields =
      ({ path, textfieldSelector, typeahead }) =>
      ($dom) => {
        $dom
          .get(0)
          .querySelectorAll(textfieldSelector)
          .forEach((element) => {
            const effectivePath = path(element)
            new AutoComplete({ element, path: effectivePath, typeahead })
            element.focus()
          })
      }

    const setupTextFields = makeSetupTextFields({
      path,
      textfieldSelector,
      typeahead,
    })

    const setupOnInsertedElement = (_e, insertedItem) => {
      setupTextFields(insertedItem)
    }

    onDomLoad(($dom) => {
      setupTextFields($dom)

      $dom.on('cocoon:after-insert', cocoonSelector, setupOnInsertedElement)

      removeListeners = () => {
        $dom.off('cocoon:after-insert', cocoonSelector, setupOnInsertedElement)
      }
    })

    return removeListeners
  }
